import React from "react";
import { useTranslation } from "react-i18next";

import "./OrderConfirmation.scss";

interface OrderFailProps {
	onStartOver: () => void;
}

const OrderFail: React.FC<OrderFailProps> = ({ onStartOver }) => {
	const { t } = useTranslation();

	return (
		<div className="OrderConfirmationPage">
			<div className="OrderConfirmationContent">
				<div className="ErrorMessage">
					<h1>{t("orderConfirmation.errorTitle")}</h1>
					<p>{t("orderConfirmation.errorMessage")}</p>
					<button className="StartOverButton" onClick={onStartOver}>
						{t("common.startOver")}
					</button>
				</div>
			</div>
		</div>
	);
};

export default OrderFail;
